import {
  IsDate,
  IsDefined,
  IsInstance,
  IsString,
} from 'class-validator';
import { IActivityFeedGroupToken, IActivityFeedUserToken, IActiviyFeedGroupTokens } from '../../interface/activity-feed';

export class ActivityFeedGroupToken implements IActivityFeedGroupToken {
  @IsDefined()
  @IsString()
  feedSlug: string;

  @IsDefined()
  @IsString()
  identifier: string;

  @IsDefined()
  @IsString()
  token: string;
}

export class ActiviyFeedGroupTokens implements IActiviyFeedGroupTokens {
  @IsDefined()
  @IsInstance(ActivityFeedGroupToken)
  Home: ActivityFeedGroupToken | null;
}

export class ActivityFeedUserTokenDto implements IActivityFeedUserToken {
  @IsDefined()
  @IsString()
  userId: string;

  @IsDefined()
  @IsString()
  userToken: string;

  @IsDefined()
  @IsDate()
  expDate: Date;

  @IsDefined()
  @IsInstance(ActiviyFeedGroupTokens)
  groupTokens: ActiviyFeedGroupTokens;
}
